import {configureStore} from "@reduxjs/toolkit";
import thunk, {ThunkAction, ThunkDispatch} from "redux-thunk";
import {Action, AnyAction} from "redux";

import logger from "./middleware/logger";
import {userReducer} from "./reducers/userReducer";
import {aoiReducer} from "./reducers/aoiReducer";
import {leagueReducer} from "./reducers/leagueReducer";
import {languageReducer} from "./reducers/languageReducer";
import {matchReducer} from "./reducers/matchReducer";
import {standingReducer} from "./reducers/standingReducer";
import {serverReducer} from "./reducers/serverReducer";
import {adsReducer} from "./ads/adsSlice";
import {cupReducer} from "./reducers/cupReducer";
import {teamReducer} from "./reducers/teamReducer";
import {playerReducer} from "./reducers/playerReducer";
import {statisticsReducer} from "./reducers/statisticsReducer";

export const store = configureStore({
    reducer: {
        user: userReducer,
        team: teamReducer,
        aois: aoiReducer,
        leagues: leagueReducer,
        languages: languageReducer,
        match: matchReducer,
        standing: standingReducer,
        server: serverReducer,
        ads: adsReducer,
        cup: cupReducer,
        player: playerReducer,
        statistics: statisticsReducer,
    },
    middleware: [logger, thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export function isLoading(state: RootState): boolean {
    return (
        state.match.statusMatchDays === "loading" ||
        state.match.status === "loading" ||
        state.user.status === "loading" ||
        state.standing.status === "loading" ||
        state.leagues.status === "loading"
    );
}
